export enum UserTypes {
    GYA_ADMIN = "GYA_ADMIN",
    COMPANY_ADMIN = "COMPANY_ADMIN",
    BRANCH_ADMIN = "BRANCH_ADMIN",
    BRANCH_STAFF = "BRANCH_STAFF",
    VENDOR = "VENDOR"
}
